/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_ApplyInputs */

const en_planner_apply = /** @type {(inputs: Planner_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to plan`)
};

const de_planner_apply = /** @type {(inputs: Planner_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen`)
};

/**
* | output |
* | --- |
* | "Add to plan" |
*
* @param {Planner_ApplyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_apply = /** @type {((inputs?: Planner_ApplyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_ApplyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_apply(inputs)
	return en_planner_apply(inputs)
});